// Brain-local duplicate of `sanitizeAlias` (app: src/storage/aliases.ts). The
// rest of that module is browser-localStorage-backed (app-only, headless JSC
// has no `localStorage`); this one function is pure string processing with no
// dependencies, so it is copied verbatim here rather than pulling the whole
// module — and app's storage/aliases.ts is unmodified, so the two stay
// byte-identical unless someone edits the rule (docs/08 §3) in only one place.

/**
 * Canonicalize a raw alias (docs/08 §3): trim, strip control characters, cap at
 * 64 runes (same cap as DisplayName). Pure — no browser deps — so the brain can
 * import it. An empty result means "clear the alias".
 */
export function sanitizeAlias(raw: string): string {
  // Strip C0/C1 control characters (incl. newlines/tabs) so an alias is a
  // single clean line, then trim surrounding whitespace.
  const stripped = raw.replace(/[\u0000-\u001F\u007F-\u009F]/g, '').trim();
  // Cap by RUNE (code point), not UTF-16 unit — matches the DisplayName rule.
  const runes = [...stripped];
  return runes.length > 64 ? runes.slice(0, 64).join('') : stripped;
}
